// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"93":"08a7df82","795":"e51e88b9","797":"132f43da","813":"c10a7549"}[chunkId] + ".css";
};